import React, { useId } from 'react'
import PropTypes from 'prop-types'

const MapIcon = React.forwardRef(function MapIcon(props, ref) {
  const { color, size, ...otherProps } = props
  const clipPathId = useId()

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path d="M23.39 3.0799L16.39 0.0799023C16.39 0.0799023 16.38 0.0799023 16.37 0.0799023C16.32 0.0599023 16.27 0.0499023 16.22 0.0399023C16.19 0.0399023 16.16 0.0199023 16.13 0.0199023C16.08 0.0199023 16.02 0.0199023 15.97 0.0199023C15.94 0.0199023 15.92 0.0199023 15.89 0.0199023C15.84 0.0199023 15.79 0.0399023 15.74 0.0499023C15.71 0.0499023 15.68 0.0599023 15.65 0.0699023C15.65 0.0699023 15.65 0.0699023 15.64 0.0699023L8.02 2.9299L1.39 0.0799023C1.09 -0.0500977 0.73 -0.0200977 0.45 0.159902C0.17 0.349902 0 0.659902 0 0.989902V19.9899C0 20.3899 0.24 20.7499 0.61 20.9099L7.61 23.9099C7.61 23.9099 7.64 23.9099 7.65 23.9099C7.76 23.9499 7.88 23.9799 8 23.9799C8.11 23.9799 8.22 23.9599 8.32 23.9199C8.32 23.9199 8.34 23.9199 8.35 23.9199L15.97 21.0599L22.6 23.8999C22.73 23.9499 22.86 23.9799 22.99 23.9799C23.18 23.9799 23.37 23.9199 23.54 23.8099C23.82 23.6199 23.99 23.3099 23.99 22.9799V3.9999C23.99 3.5999 23.75 3.2399 23.38 3.0799H23.39ZM2 2.5199L7 4.6599V21.4799L2 19.3399V2.5199ZM9 4.6999L15 2.4499V19.3099L9 21.5599V4.6899V4.6999ZM22 21.4899L17 19.3499V2.5199L22 4.6599V21.4799V21.4899Z"></path>
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <path fill="white" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
})

MapIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

MapIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default MapIcon
